const REMOVE_DELAY = 220;

function removeLoader(loader) {
  loader.classList.add("startup-loader--leaving");
  window.setTimeout(() => {
    if (loader.parentNode) {
      loader.parentNode.removeChild(loader);
    }
  }, REMOVE_DELAY);
}

export function hideStartupLoaderAfterFirstPaint(vm) {
  vm.$nextTick(() => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const loader = document.getElementById("startup-loader");
        window.clearTimeout(window.__startupLoaderFallback);
        if (loader) {
          removeLoader(loader);
        }
      });
    });
  });
}
